import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { EnquiryImageInput, EnquiryType } from '@/graphql/api'

export const useEnquiryFormStore = defineStore('enquiryForm', () => {
    const enquiryType = ref<EnquiryType | null>(null)
    const enquiryImage = ref<EnquiryImageInput | null>(null)
    const isFetching = ref(false)

    const openEnquiryForm = (type: EnquiryType, image?: EnquiryImageInput) => {
        enquiryType.value = type
        enquiryImage.value = image || null
    }

    const closeEnquiryForm = () => {
        enquiryType.value = null
        enquiryImage.value = null
        isFetching.value = false
    }

    return {
        enquiryType,
        enquiryImage,
        isFetching,
        openEnquiryForm,
        closeEnquiryForm,
    }
})
